<template>
  <v-select
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    :items="networks"
    item-title="name"
    item-value="id"
    label="Rede"
    return-object
    variant="outlined"
    density="compact"
    class="network-selector"
    style="max-width: 200px"
  >
    <template v-slot:selection="{ item }">
      <div class="d-flex align-center">
        <v-avatar size="24" :color="item.raw.color" class="mr-2">
          <span class="text-caption">{{ item.raw.icon }}</span>
        </v-avatar>
        {{ item.raw.name }}
      </div>
    </template>
    <template v-slot:item="{ item, props }">
      <v-list-item v-bind="props">
        <template v-slot:prepend>
          <v-avatar size="24" :color="item.raw.color">
            <span class="text-caption">{{ item.raw.icon }}</span>
          </v-avatar>
        </template>
        <v-list-item-title>{{ item.raw.name }}</v-list-item-title>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'NetworkSelector',
  props: {
    modelValue: {
      type: Object,
      required: true
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      networks: [
        { id: 'quarnx', name: 'QuarnX', color: 'primary', icon: 'Q' },
        { id: 'ethereum', name: 'Ethereum', color: '#6B7FFF', icon: 'E' },
        { id: 'bsc', name: 'BSC', color: '#F0B90B', icon: 'B' },
        { id: 'polkadot', name: 'Polkadot', color: '#E6007A', icon: 'P' }
      ]
    }
  }
}
</script>

<style scoped>
.network-selector {
  min-width: 140px;
}
</style>
